import { render, staticRenderFns } from "./Integracoes.vue?vue&type=template&id=3192c09f&scoped=true"
import script from "./Integracoes.vue?vue&type=script&lang=js"
export * from "./Integracoes.vue?vue&type=script&lang=js"
import style0 from "./Integracoes.vue?vue&type=style&index=0&id=3192c09f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192c09f",
  null
  
)

export default component.exports